import React from "react";
import GitInfo from 'react-git-info/macro';
import { FlexContainer, Text } from "../../design";
import { Col } from "react-awesome-styled-grid";

const gitInfo = GitInfo();

const Release = () => {
    return (
        <FlexContainer
            flexDirection="column"
            justifyContent="center"
            alignContent="center"
            className="w-100"
        >
            <Col style={{ width: "inherit" }} xs={8} sm={4} md={4} lg={6} xl={5}>
                <FlexContainer
                    display="block"
                    marginTop="5rem"
                    borderRadius="10px"
                    boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    justifyContent="center"
                    alignContent="center"
                    paddingTop="3rem"
                    paddingRight=".5rem"
                    paddingBottom="3rem"
                    paddingLeft=".5rem"
                    backgroundColor="white"
                    className="text-center"
                >
                    <Text
                        fontSize="16px"
                        textAlign="center"
                        color="#000000"
                        paddingRight="3rem"
                        paddingBottom="3rem"
                        paddingLeft="3rem"
                    >
                        Commit SHA: {gitInfo.commit.hash}
                    </Text>
                    <Text
                        fontSize="16px"
                        textAlign="center"
                        color="#000000"
                        paddingRight="3rem"
                        paddingBottom="3rem"
                        paddingLeft="3rem"
                    >
                        Commit: {gitInfo.commit.shortHash}
                    </Text>
                </FlexContainer>
            </Col>
        </FlexContainer>
    )
};

export default Release;
